import { render } from "./AppHeader.vue?vue&type=template&id=9337624c&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=9337624c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9337624c"]])

export default __exports__